var _desc, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAeroperformLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 1024,
    viewBox: "0 0 1280 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 640 512)",
    id: "background-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    x: -640,
    y: -512,
    rx: 0,
    ry: 0,
    width: 1280,
    height: 1024
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6518012227257772 0 0 3.6518012227257772 640.8595652864557 512.8992375304459)",
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    paintOrder: "stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.808529853365531 0 0 -1.808529853365531 0 10.026127801087824)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(17,140,210)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(90, -5.57)",
    d: "M 0 0 C 0 -16.06 -13.02 -29.09 -29.09 -29.09 C -32.24 -29.09 -35.269999999999996 -28.58 -38.11 -27.65 C -39.79 -42.12 -52.08 -53.36 -67 -53.36 C -77.28 -53.36 -86.32 -48.01 -91.49 -39.96 C -80.63 -33 -70.25999999999999 -16.02 -68.06 22.549999999999997 C -96 -73.43 -135.07999999999998 -24.400000000000006 -135.07999999999998 -24.400000000000006 C -139.64 -27.360000000000007 -145.07 -29.090000000000007 -150.91 -29.090000000000007 C -166.98 -29.090000000000007 -180 -16.06000000000001 -180 -7.105427357601002e-15 C -180 16.069999999999993 -166.98 29.099999999999994 -150.91 29.099999999999994 C -150.13 29.099999999999994 -149.35999999999999 29.059999999999995 -148.59 28.999999999999993 C -144.28 42.08999999999999 -131.95 51.55 -117.41 51.55 C -111.96 51.55 -106.82 50.22 -102.3 47.87 C -93.89999999999999 58.019999999999996 -81.19999999999999 64.5 -67 64.5 C -44.989999999999995 64.5 -26.619999999999997 48.97 -22.22 28.270000000000003 C -9.47 25.19 0 13.71 0 0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.808529853365531 0 0 -1.808529853365531 37.41902522508889 -68.64238887851806)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(134,72,121)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-8.5635, -21.165)",
    d: "M 0 0 L 9.813 -5.354 L 5.967 2.218 L 17.545 46.57 L 17.653 47.684 L 16.892 46.192 L -0.526 0.561 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.808529853365531 0 0 -1.808529853365531 36.50915385586069 -30.355811882769785)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(67,36,61)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(-3.3855, 1.7534999999999998)",
    d: "M 0 0 L 5.138 -7.102 L 6.598 2.396 L 6.771 3.595 L 1.023 1.409 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.808529853365531 0 0 -1.808529853365531 26.158756652064426 -68.89522135201858)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(233,166,166)",
      fillRule: "nonzero",
      opacity: 1
    },
    paintOrder: "stroke",
    transform: " translate(16.3125, -14.481999999999998)",
    d: "M 0 0 L -0.997 40.861 L -13.975 -5.074 Z M -32.625 -11.897 L -0.997 40.861 L -18.65 -6.823 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroperformLogo);
export default __webpack_public_path__ + "static/media/aeroperform_logo.607d7437812dee61cfa14acaed15f9c0.svg";
export { ForwardRef as ReactComponent };